module.exports = __webpack_public_path__ + "static/media/box.0225a2df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Header/components/Title/Icons/box.svg
// module id = 73
// module chunks = 0